define('shared/util/adyen/getSDKConfig',[
    'Promise',
    'shared/util/hub',
    'shared/page/language',
    'shared/page/market',
    './getEnv'
],
function(
    Promise,
    hub,
    getLanguage,
    getMarket,
    getEnv
) {
    function getTranslationsConfig() {
        return Promise.all([
            hub.get('adyen/translation/current'),
            getLanguage(),
            getMarket()
        ])
            .then(function(values){
                var translations = values[0];
                var language = values[1];
                var market = values[2];

                if (!translations) {
                    return null;
                }

                var translationsConfig = {};
                var locale = language.toLowerCase() + '_' + market.toUpperCase();
                for(var key in translations) {
                    if (!translations.hasOwnProperty(key)) {
                        continue;
                    }

                    translationsConfig[key] = {};
                    translationsConfig[key][locale] = translations[key];
                }

                return translationsConfig;
            });
    }

    return function () {
        var config = {};
        return getEnv()
            .then(function(env){
                config.context = env;

                return config;
            })
            .then(function() {
                return getTranslationsConfig();
            })
            .then(function (translationsConfig) {
                if (translationsConfig) {
                    config.translations = translationsConfig;
                    config.allowAddedLocales = true;
                }
                return config;
            });
    };
});
